import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';

import Header from '../Header/Header';
import { fetchMachineData, sendFilesToMachine } from '@custom/Apis/apis';
import { servicesManager } from '../../app/src/App';
import { useTheme } from "../../ui/src/contextProviders"
import { customStyle } from '@custom/Utils/utils';



const SendToMachine = () => {

  const pageData = useLocation();
  const navigate = useNavigate();

  const { uiNotificationService } = servicesManager?.services;

  const [fileInfo, setFileInfo] = useState(null);
  const [selectedMachine, setSelectedMachine] = useState('');
  const [machineList, setMachineList] = useState([]);
  const [countSuccessFiles, setCountSuccessFiles] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const formatTime = (timeString) => {
    if (!timeString) return '';

    const hours = parseInt(timeString.substring(0, 2), 10);
    const minutes = timeString.substring(2, 4);
    const period = hours >= 12 ? 'PM' : 'AM';

    const formattedHours = hours % 12 || 12;
    return `${formattedHours}:${minutes} ${period}`;
  };

  const formatDate = (value) => {
    if (!value) {
      return '';
    }

    const year = value?.substring(0, 4);
    const month = value?.substring(4, 6);
    const day = value?.substring(6, 8);

    return `${day}-${month}-${year}`;
  }

  const getValueSafely = (tag, item) => {
    try {
      const value = item?.[tag]?.Value?.[0];
      if (tag === '00080020' && value) {
        return formatDate(value);
      }
      if (tag === '00080030' && value) {
        return formatTime(value);
      }
      return value ?? '';
    } catch (error) {
      return '';
    }
  };

  const handleCancelClick = () => {
    navigate(-1);
  }

  const populateMachineData = async () => {
    try {
      const res = await fetchMachineData();

      if (res?.ok) {
        const data = await res?.json();
        setMachineList(data);
      }
      else {
        uiNotificationService.show({
          title: 'Error',
          message: 'Unable to fetch machine details.',
          type: 'error',
          position: 'topRight'
        })
      }
    }
    catch (error) {
      uiNotificationService.show({
        title: 'Error',
        message: 'Unable to fetch machine details.',
        type: 'error',
        position: 'topRight'
      })
    }
  }

  const getStudyInstanceUID = () => {
    return getValueSafely('0020000D', pageData?.state?.seriesData[0])
  }

  const handleSendingFies = async () => {
    setCountSuccessFiles(0);
    let count = 0;

    if (selectedMachine === '') {
      uiNotificationService.show({
        title: 'Warning',
        message: 'Please select a destination.',
        type: 'error',
        position: 'topRight'
      })
      return;
    }

    setIsLoading(true);

    const payload = {
      machineName: selectedMachine,
      isSendingSeries: pageData?.state?.isSendingSeries,
      data: pageData?.state?.isSendingSeries ? {
        studyInstanceUID: getStudyInstanceUID(),
        selectedSeriesInstanceUIDs: pageData?.state?.selectedItems
      }
        : {
          selectedStudyInstanceUIDs: pageData?.state?.studiesToSend?.map(study => study?.studyInstanceUid)
        }
    }

    try {
      const resp = await sendFilesToMachine(payload);

      const successfulResponses = resp.map(response => {
        if (!response.ok) {
          console.log(`Request failed with status ${response.status} for ${response.url}`);
        }
        else {
          count++;
        }
        return response;
      });

      const data = await Promise.all(successfulResponses.map(response => response.json()));
      console.log('Data:', data);

      if (count > 0) {
        uiNotificationService.show({
          title: 'Success',
          message: `${count} files sent successfully.`,
          type: 'success',
          position: 'topRight'
        })
      }
      else {
        uiNotificationService.show({
          title: 'Error',
          message: 'Error while sending files',
          type: 'error',
          position: 'topRight'
        })
      }

      setCountSuccessFiles(count);
      setIsLoading(false);
    }
    catch (error) {
      uiNotificationService.show({
        title: 'Error',
        message: 'Error while sending files',
        type: 'error',
        position: 'topRight'
      })
      setIsLoading(false);
    }
  }

  const handleMachineChange = (event) => {
    setSelectedMachine(event.target.value);
  }

  useEffect(() => {
    setFileInfo(pageData?.state);
  }, [pageData])

  useEffect(() => {
    populateMachineData();
  }, [])

  const isDarkMode = useTheme();

  console.log(isDarkMode)

  return (
    <div className='page page__full' style={
      isDarkMode?.isDarkMode ? { background: '#090c29' } : customStyle.mainBackground
    } >
      <Header isBack={true} title='Studies'></Header>
      <div className='page__body'>
        <div className='details'>
          <div className='flex flex-col gap-2 text-sm'>
            {
              pageData?.state?.isSendingSeries ? fileInfo?.selectedItems?.map((item, idx) => {

                const currSeriesInfo = fileInfo?.seriesData?.find(i => getValueSafely('0020000E', i) === item);

                return (<div key={idx} className='p-4 flex justify-between text-[#49475A]' style={{
                  border: '1px solid #49475a99',
                  borderRadius: '10px',
                }}>
                  <div className='flex-1'> <span className='font-bold'>Patient Name : </span> {getValueSafely('00100010', currSeriesInfo)?.Alphabetic} </div>
                  <div className='flex-1'> <span className='font-bold'>Modality : </span> {getValueSafely('00080060', currSeriesInfo)} </div>
                  <div className='flex-1'> <span className='font-bold'>Study : </span> {getValueSafely('00081030', currSeriesInfo)} </div>
                  <div className='flex-1'> <span className='font-bold'>Study Date : </span> {getValueSafely('00080020', currSeriesInfo)} </div>
                  <div className='flex-1'> <span className='font-bold'>Series : </span> {getValueSafely('0008103E', currSeriesInfo)} </div>
                </div>);
              }) :
                fileInfo?.studiesToSend?.map((item, idx) => {

                  return (<div key={idx} className='p-4 flex justify-between text-[#49475A]' style={{
                    border: '1px solid #49475a99',
                    borderRadius: '10px'
                  }}>
                    <div className='flex-1'> <span className='font-bold'>Patient Name : </span> {item?.patientName} </div>
                    <div className='flex-1'> <span className='font-bold'>Modality : </span> {item?.modalities} </div>
                    <div className='flex-1'> <span className='font-bold'>Study : </span> {item?.description} </div>
                    <div className='flex-1'> <span className='font-bold'>Study Date : </span> {formatDate(item?.date)} </div>
                    <div className='flex-1'> <span className='font-bold'>Series : </span> {'[All]'} </div>
                  </div>);
                })
            }

            <div className='w-2/3 flex justify-between py-4'>
              <div className='flex gap-[10px] items-center'>
                <span className='font-bold'>Destination </span>
                <select className='form__select form__select--sm' value={selectedMachine} onChange={handleMachineChange}>
                  <option value='' disabled={true} >Select an option</option>
                  {
                    machineList?.map((item, idx) => {
                      return (<option key={idx} value={item?.dicomAETitle}> {item?.dicomDeviceName} </option>);
                    })
                  }
                </select>
              </div>

              <div className='flex gap-1 items-center'>
                <span className='font-bold'>Total Images: </span>
                <span className='text-[#0EA7A2]'>
                  {pageData?.state?.isSendingSeries ? fileInfo?.selectedItems?.length : pageData?.state?.studiesToSend?.length}
                </span>
              </div>

              <div className='flex gap-1 items-center'>
                <span className='font-bold'>Sent Images: </span>
                <span className='text-[#0EA7A2]'>
                  {countSuccessFiles}
                </span>
              </div>
            </div>

            <div className='py-4'>
              <div className='font-bold'>Description </div>
              <textarea className='w-full border-2 rounded-lg color-gray-800 mt-2 p-3' placeholder='Enter Description' >
              </textarea>
            </div>

            <div className='flex gap-4 items-center'>
              <button className='btn btn__white' onClick={handleCancelClick}>Cancel</button>
              <button className='py-1 box-content inline-flex flex-row items-center justify-center gap-[5px] justify center px-4 outline-none rounded leading-[1.2] font-sans text-center whitespace-nowrap bg-[#51A196] text-white transition duration-300 ease-in-out focus:outline-none hover:bg-[#51A196] active:bg-[#51A196] h-[32px] text-[14px] min-w-[32px]' disabled={isLoading} onClick={handleSendingFies}>{isLoading ? 'Sending...' : 'Start'}</button>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default SendToMachine;
